import * as React from "react";
import { useTheme } from "../context/ThemeContext";

const techStacks = [
  { name: "HTML", img: "/assets/html.png"},
  { name: "CSS", img: "/assets/css.png"},
  { name: "TailwindCSS", img: "/assets/tcss.png"},
  { name: "JavaScript", img: "/assets/js.png"},
  { name: "TypeScript", img: "/assets/ts.png", },
  { name: "React", img: "/assets/react.png"},
  { name: "Bootstrap", img: "/assets/bootstrap.png"},
  { name: "Python", img: "/assets/python.png"},
  { name: "Laravel", img: "/assets/laravel.png"},
  { name: "NodeJS", img: "/assets/node.png"},
  { name: "ExpressJS", img: "/assets/express.png"},
  { name: "InertiaJS", img: "/assets/inertia.png"},
];

const TechStack: React.FC = () => {
  const { isDarkMode } = useTheme();
  
  const textColor = isDarkMode ? 'text-tertiary' : 'text-gray-600';
  const bgColor = isDarkMode ? 'bg-gray-900' : 'bg-gray-300';
  const cardHoverGradient = isDarkMode 
    ? 'hover:from-[#83329A] hover:to-[#242f47]'
    : 'hover:from-[#83329A] hover:to-[#707374]';
  
  return (
    <div 
      id="techstacks"
      className={`text-center py-8 ${bgColor} transition-colors duration-300`}
    >
      <h2 className="text-3xl font-bold mb-3" style={{ color: "#83329A" }}>
        TechStacks
      </h2>
      <p className={`mt-3 mb-8 text-lg ${textColor} transition-colors duration-300`}>
        Here are the tools & technologies I use
      </p>
      <div className="px-6 md:px-16 lg:px-24 max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {techStacks.map((tech, index) => (
            <div
              key={index}
              className={`px-8 py-4 rounded-lg flex flex-col items-center justify-center shadow-lg transition-all transform hover:scale-105 bg-[#A988D8] hover:bg-gradient-to-r ${cardHoverGradient} font-semibold`}
            >
              <img 
                src={tech.img} 
                alt={tech.name} 
                className="w-13 h-12 mb-1 transition-colors duration-300 hover:filter-none" 
              />
              <span className={`${isDarkMode ? 'text-white' : 'text-gray-800'} text-sm font-medium transition-colors duration-300 hover:text-gray-300`}>
                {tech.name}
              </span>
            </div>
          ))}        
        </div>
        <p className={`mt-5 mb-3 text-lg ${textColor} transition-colors duration-300`}>
          Continuously growing my tech expertise
        </p>
      </div>
    </div>
  );
};

export default TechStack;